import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createAzureFwIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M17.1533 23.679H12.6889V25.6546H17.1533V23.679Z" fill="white"/>
    <path d="M22.2867 23.679H17.8222V25.6546H22.2867V23.679Z" fill="white"/>
    <path d="M27.42 23.679H22.9556V25.6546H27.42V23.679Z" fill="white"/>
    <path d="M14.54 26.3234H12.6889V27.9516V28.299H14.54V28.0034V26.3234Z" fill="white"/>
    <path d="M27.42 26.3234H25.5689V28.0034V28.299H27.42V28.008V26.3234Z" fill="white"/>
    <path d="M19.6733 26.3234H15.2089V28.0034V28.299H19.6733V28.0034V26.3234Z" fill="white"/>
    <path d="M24.8222 26.3234H20.3578V28.0034V28.299H24.8222V28.0034V26.3234Z" fill="white"/>
    <path d="M17.1533 28.9679H12.6889V30.9434H17.1533V28.9679Z" fill="white"/>
    <path d="M22.2867 28.9679H17.8222V30.9434H22.2867V28.9679Z" fill="white"/>
    <path d="M27.42 28.9679H22.9556V30.9434H27.42V28.9679Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3767 17.757C33.3761 18.8646 33.9512 20.2902 34 21.7812C33.9597 23.4349 33.2785 25.0082 32.1002 26.1692C31.0518 27.202 29.683 27.8365 28.2289 27.975V23.4146C28.2248 23.244 28.1542 23.0818 28.0321 22.9626C27.91 22.8434 27.7462 22.7767 27.5756 22.7768H12.4244C12.2538 22.7767 12.09 22.8434 11.9679 22.9626C11.8458 23.0818 11.7752 23.244 11.7711 23.4146V27.7814C10.5329 27.4724 9.38053 26.8544 8.42886 25.9703C6.95044 24.5969 6.07698 22.6932 6 20.6768C6.05406 18.8836 6.74927 17.1693 7.95944 15.8449C9.16961 14.5206 10.8145 13.6741 12.5956 13.459C13.1822 11.8777 14.2458 10.5178 15.6392 9.56747C17.0327 8.61716 18.687 8.12341 20.3733 8.15455C22.4569 8.09117 24.4816 8.85035 26.0098 10.268C27.5381 11.6856 28.447 13.6477 28.54 15.7301C30.0182 15.9314 31.3774 16.6495 32.3767 17.757ZM12.6889 27.9516V28.299H14.54V28.0034V26.3234H12.6889V27.9516ZM15.2089 28.0034V28.299H19.6733V28.0034V26.3234H15.2089V28.0034ZM20.3578 28.0034V28.299H24.8222V28.0034V26.3234H20.3578V28.0034ZM25.5689 28.0034V28.299H27.42V28.008V26.3234H25.5689V28.0034ZM17.1533 28.9679H12.6889V30.9434H17.1533V28.9679ZM22.2867 28.9679H17.8222V30.9434H22.2867V28.9679ZM27.42 28.9679H22.9556V30.9434H27.42V28.9679ZM12.6889 23.679H17.1533V25.6546H12.6889V23.679ZM17.8222 23.679H22.2867V25.6546H17.8222V23.679ZM22.9556 23.679H27.42V25.6546H22.9556V23.679Z" fill="white"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const azureFwIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAzureFwIcon,
);
